import { ThemePerformanceParams } from '@api';
import { useGetV5ThemePerformance } from '@terminal/react-query-hooks/themes/useGetV5ThemePerformance';
import { useMemo } from 'react';

export const useGetThemePerformance = (
  params?: ThemePerformanceParams,
  enabled = true
) => {
  const v5ThemePerformance = useGetV5ThemePerformance(params, enabled);

  const themes = useMemo(
    () => v5ThemePerformance.data?.pages?.flatMap(p => p.themes),
    [v5ThemePerformance.data]
  );

  return {
    ...v5ThemePerformance,
    themes,
    hasAnyError: v5ThemePerformance.isError,
  };
};
